import { render, staticRenderFns } from "./clueManagement.vue?vue&type=template&id=009f8839&"
import script from "./clueManagement.vue?vue&type=script&lang=js&"
export * from "./clueManagement.vue?vue&type=script&lang=js&"
import style0 from "./clueManagement.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports